import React from 'react';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'
import { Button, Divider, Grid, Switch } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';
import { ReactComponent as TrashAltSolid } from '../../module/chestionare/Icoane Font Awesome/trash-alt-solid.svg'
import { ReactComponent as PenSolid } from '../../module/chestionare/Icoane Font Awesome/pen-solid.svg'
import Masks from '../../providers/Masks';
import AlertNew from '../../commons/dialogs/AlertNew';
import LocalStorage from '../../providers/LocalStorage';

export default class FisaPersonalaAngajare extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            dataStart: this.u.defaultData(),
            concediuMedical: 0,
            concediuOdihna: 0,
            concediuZileSpeciale: 0,
            alteConcedii: 0,
            zileConcediu: 0,
            permis: this.props.angajat.permis_conducere ? true : false,
            docs: [],
            vCnp: '',
            vTel: '',
            vSerie: '',
            alertView: false
        }
    }

    componentDidMount() {
    
        this.getDocumenteAngajat()

    }

    u = new Utils();
    ws = new Ws()
    m = new Masks()

   

    numeAvatar = (nume) => {

        if (nume) {
            let n = nume.split(' ')

            // console.log('n :>> ', n);

            let firstLetters = ''

            if (n[0]) {

                firstLetters += n[0].substring(0, 1)

            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }

            firstLetters = firstLetters.toUpperCase()

            return firstLetters
        } else {
            return 'NA'
        }


    }


    getDocumenteAngajat = async () => {

        console.log('this.props.angajat.id :>> ', this.props.angajat.id);

        let getDocumente = await this.ws.customSelect('select * from angajati_documente where id_angajat = @p1', {
            p1: this.props.angajat.id
        })


        console.log('getDocumente :>> ', getDocumente);


        if (getDocumente.Succes) {

            let docs = [...getDocumente.Content]

            let newDocs = []

            let docsLength = docs.length


            for (let i = 0, n = 12; i < n; i++) {


                let doc = {}

                if (docsLength > 0) {

                    doc['name'] = docs[i]['nume']
                    doc['token'] = docs[i]['token']
                    doc['icon'] = 'image'
                    doc['icon_color'] = 'black'
                    doc['icon_font'] = '30px'

                    newDocs.push(doc)

                    docsLength = docsLength - 1

                } else {
                    doc['name'] = 'Adauga Document'
                    doc['icon'] = 'add_photo_alternate'
                    doc['icon_color'] = 'rgb(121 121 121)'
                    doc['icon_font'] = '24px'

                    newDocs.push(doc)
                }

            }


            this.setState({ docs: newDocs })

            console.log('newDocs :>> ', newDocs);

        }

    }



    goToDoc = (doc) => {
        window.open(`${new Ws().adresaMedia}/Angajati/${doc.token}`)

    }





    selectFile = (id) => {
        //  console.log('Incepe poza');
        let pi = document.getElementById(id);

        pi.click()
    }


    uploadDocument = async (id, idAngajat) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        // let chPoza = document.getElementById(bkId)




        reader.onload = async () => {
            let fileContent = reader.result;

            // console.log(fileContent);
            // console.log('saveFile :', saveFile);




            let uploadDocument = await ws.uploadimage('Upload/DocumentAngajat', saveFile, idAngajat);

            console.log('uploadDocument :>> ', uploadDocument);

            // console.log('uploadImage :', uploadImage);
            if (uploadDocument.Succes) {

                this.getDocumenteAngajat()


            }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    uploadPoza = async (id, idAngajat, bkId) => {


        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        let reader = new FileReader();
        reader.readAsDataURL(saveFile);

        let chPoza = document.getElementById(bkId)




        reader.onload = async () => {
            let fileContent = reader.result;
            chPoza.style.backgroundImage = ` url(${fileContent})`
            // console.log(fileContent);
            // console.log('saveFile :', saveFile);


            let uploadImage = await ws.uploadimage('Upload/PozaAngajat', saveFile, idAngajat);

            // let uploadDocument = await ws.uploadimage('Upload/DocumentAngajat', saveFile, idAngajat);

            // console.log('uploadDocument :>> ', uploadDocument);

            console.log('uploadImage :', uploadImage);
            // if (uploadImage.Succes) {




            // }
            //console.log('uploadimage :', uploadImage);
            // console.log('uploadFileApiCall :', uploadFileApiCall);

        }

    }

    validateInput = (n) => {
        let ang = { ...this.props.angajat }

        if (n === 'cnp') {
            let substrCnp1stLetter = ang[n].substring(0, 1)


            let substrCnpLuna = ang[n].substring(3, 5)

            let substrCnpZi = ang[n].substring(5, 7)


            let cnpLength = ang[n].length

            let cnpValidate = false

            console.log('substrCnpZi :>> ', substrCnpZi);

            if (substrCnp1stLetter > 0 && substrCnp1stLetter <= 2) {
                console.log('substrCnp1stLetter :>> ', substrCnp1stLetter);
                cnpValidate = true

                if (Number(substrCnpLuna) > 0 && Number(substrCnpLuna) <= 12) {
                    console.log('substrCnpLuna :>> ', substrCnpLuna);
                    cnpValidate = true
                    let nDate = new Date().setMonth(Number(substrCnpLuna) - 1)
                    nDate = new Date(nDate)
                    let lastDayMonth = new Date(this.m.lastDayMonth(nDate)).getDate()

                    console.log('lastDayMonth :>> ', lastDayMonth);
                    console.log('this.m.lastDayMonth(nDate) :>> ', this.m.lastDayMonth(nDate));
                    if (Number(substrCnpZi) > 0 && Number(substrCnpZi) <= lastDayMonth) {
                        console.log('substrCnpZi :>> ', substrCnpZi);
                        cnpValidate = true

                        if (cnpLength === 13) {
                            cnpValidate = true
                        } else {
                            cnpValidate = false
                        }
                    } else {
                        cnpValidate = false
                    }


                } else {
                    cnpValidate = false
                }
            }








            if (cnpValidate) {
                this.setState({ vCnp: '' }, () => {
                    this.props.updateAngajatData()
                })
            } else {
                this.setState({ vCnp: this.dictionary.managementUtilizatori.verifyCnp })
            }
        } else if (n === 'telefon') {

            let telValidate = false

            if (ang[n].length === 10) {

                telValidate = true
            }


            if (telValidate) {
                this.setState({ vTel: '' }, () => {
                    this.props.updateAngajatData()
                })
            } else {
                this.setState({ vTel: this.dictionary.managementUtilizatori.verifyTel })
            }
        } else if (n === 'serie_ci') {
            let serieValidate = false

            let firstLetter = ang[n].substring(0, 1)
            let secondLetter = ang[n].substring(1, 2)

            if (isNaN(firstLetter) && isNaN(secondLetter)) {
                let serieLength = ang[n].length

                if (serieLength === 8) {
                    serieValidate = true
                } else {
                    serieValidate = false
                }
            }

            if (serieValidate) {
                this.setState({ vSerie: '' }, () => {
                    this.props.updateAngajatData()
                })
            } else {
                this.setState({ vSerie: this.dictionary.managementUtilizatori.verifySerie })
            }


        }
    }


    render() {
        return (
            <Grid container>

               


                <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
                    <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll', width: '90%', }}>


                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <input type='file' id={`file${this.props.angajat.id}`}
                                style={{ display: 'none' }}
                                accept='image/*'
                                onChange={() => { this.uploadPoza(`file${this.props.angajat.id}`, this.props.angajat.id, 'angajat-upload-poza') }} />

                            <div
                                id={'angajat-upload-poza'}
                                onClick={() => { this.selectFile(`file${this.props.angajat.id}`) }}
                                className='pm-angajati-picture-update'
                                style={{
                                    backgroundImage: `url('${this.props.angajat.poza ? (new Ws().adresaMedia + '/Angajati/' + this.props.angajat.poza) : avatar}')`,
                                    position: 'relative',
                                    left: 0,
                                    top: 0
                                }}>

                                <i style={{
                                    backgroundColor: 'white',
                                    padding: 5,
                                    borderRadius: '50%',
                                    position: 'absolute',
                                    bottom: 5,
                                    right: 0
                                }} className="material-icons">photo_camera</i>

                            </div>


                            <h3 className='pm-angajat-titlu'>{this.props.angajat.nume}</h3>
                            <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{this.props.angajat.functie} - {this.props.angajat.nume_departament}</span>

                            <Divider style={{ marginTop: 20 }} className='pm-divider' />
                        </Grid>




                        <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h4 className='pm-fisa-angajat-subtitlu' > {this.dictionary.pontaje.status}</h4>

                            <Grid container>
                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <div style={{ display: 'inline-block', marginLeft: 10, marginTop: 10 }}>
                                        <div style={{ backgroundColor: 'rgb(227	51	59)', verticalAlign: 'middle', borderRadius: 10, height: 12, width: 12, marginRight: 5 }} className='pm-task-legend'></div>
                                        <span style={{ marginRight: 20, fontSize: 14, fontWeight: 600 }}>{this.u.statusAngajati[2]}</span>

                                    </div>
                                </Grid>


                                <Grid style={{ textAlign: 'right', paddingTop: 5 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <PenSolid style={{ marginRight: 0, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                    <TrashAltSolid style={{ marginLeft: 10, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                </Grid>


                            </Grid>

                            <Divider style={{ marginTop: 20 }} className='pm-divider' />

                        </Grid>


                        <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <h4 className='pm-fisa-angajat-subtitlu' > {this.dictionary.pontaje.dateCompanie}</h4>


                            <Grid style={{ marginBottom: 20 }} container>
                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', backgroundColor: 'transparent' }}
                                            id='email'
                                            type="text"
                                            step='any'
                                            disabled={this.state.readOnly}
                                            className='add-project-input'
                                            placeholder='Completeaza datele'
                                            margin="normal"
                                            name='email'
                                            value={this.props.angajat.email || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='email'>{this.dictionary.pontaje.email}</label>
                                    </div>
                                </Grid>

                                {this.state.readOnly &&

                                    <Grid style={{ textAlign: 'right', paddingTop: 5 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <PenSolid style={{ marginRight: 0, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                        <TrashAltSolid style={{ marginLeft: 10, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                    </Grid>
                                }




                            </Grid>

                            <Grid style={{ marginBottom: 20 }} container>
                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', backgroundColor: 'transparent' }}
                                            id='telefon1'
                                            type="number"
                                            step='any'
                                            disabled={this.state.readOnly}
                                            className='add-project-input'
                                            placeholder='Completeaza datele'
                                            margin="normal"
                                            name='telefon'
                                            value={this.props.angajat.telefon || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={() => { this.validateInput('telefon') }}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='telefon1'>{this.dictionary.pontaje.nrTelefon}</label>
                                    </div>
                                    {this.state.vTel &&
                                        <span style={{
                                            fontSize: 12,
                                            color: 'red',
                                            paddingLeft: 6
                                        }}>{this.state.vTel}</span>
                                    }
                                </Grid>

                                {this.state.readOnly &&

                                    <Grid style={{ textAlign: 'right', paddingTop: 5 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <PenSolid style={{ marginRight: 0, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                        <TrashAltSolid style={{ marginLeft: 10, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                    </Grid>
                                }




                            </Grid>


                            <Grid style={{ marginBottom: 20 }} container>
                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', backgroundColor: 'transparent' }}
                                            id='oras1'
                                            type="text"
                                            step='any'
                                            disabled={this.state.readOnly}
                                            className='add-project-input'
                                            placeholder='Completeaza datele'
                                            margin="normal"
                                            name='oras'
                                            value={this.props.angajat.oras || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='oras1'>{this.dictionary.pontaje.oras}</label>
                                    </div>
                                </Grid>

                                {this.state.readOnly &&

                                    <Grid style={{ textAlign: 'right', paddingTop: 5 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <PenSolid style={{ marginRight: 0, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                        <TrashAltSolid style={{ marginLeft: 10, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                    </Grid>
                                }




                            </Grid>

                            <Grid style={{ marginBottom: 20 }} container>
                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', backgroundColor: 'transparent' }}
                                            id='pret'
                                            type="text"
                                            step='any'
                                            disabled={this.state.readOnly}
                                            className='add-project-input'
                                            placeholder='Completeaza datele'
                                            margin="normal"
                                            name='adresa'
                                            value={this.props.angajat.adresa || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='pret'>{this.dictionary.pontaje.adresa}</label>
                                    </div>
                                </Grid>

                                {this.state.readOnly &&

                                    <Grid style={{ textAlign: 'right', paddingTop: 5 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <PenSolid style={{ marginRight: 0, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                        <TrashAltSolid style={{ marginLeft: 10, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                    </Grid>
                                }




                            </Grid>

                            <Divider style={{ marginBottom: 20 }} className='pm-divider' />

                        </Grid>


                        <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid style={{ marginBottom: 20 }} container>
                                <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
                                    <div style={{ position: 'relative' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', backgroundColor: 'transparent' }}
                                            id='pret'
                                            type="text"
                                            step='any'
                                            disabled={this.state.readOnly}
                                            className='add-project-input'
                                            placeholder='Completeaza datele'
                                            margin="normal"
                                            name='permis_conducere'
                                            value={this.props.angajat.permis_conducere || 'Indisponibil'}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='pret'>{this.dictionary.pontaje.permis}</label>
                                    </div>
                                </Grid>

                                {this.state.readOnly &&

                                    <Grid style={{ textAlign: 'right', paddingTop: 5 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                        <PenSolid style={{ marginRight: 0, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                        <TrashAltSolid style={{ marginLeft: 10, width: 16, height: 16, color: 'rgb(193 193 193)' }} />
                                    </Grid>
                                }




                            </Grid>
                        </Grid>

                    </Grid>

                    <Grid style={{ width: '90%' }} container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                            <Button
                                style={{ width: '100%' }}

                                className={'add-button-green'} onClick={this.props.angajare}  >

                                {this.dictionary.pontaje.generazaDocumenteAngajare}
                            </Button>

                        </Grid>


                    </Grid>
                </Grid>






                <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll', width: '90%', }}>
                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, marginTop: 10, fontSize:16, fontWeight:500 }} > {this.dictionary.pontaje.datePersonale}
                                        <i style={{ marginLeft: 10, color: 'rgb(24	165	58)', verticalAlign: 'bottom' }} className='material-icons'>verified</i>
                                    </h5>
                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='nume'
                                            type="text"
                                            step='any'
                                            className='add-project-input'
                                            placeholder='Ex: Ion Popescu'
                                            margin="normal"
                                            name='nume'
                                            value={this.props.angajat.nume || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='nume'>{this.dictionary.pontaje.nume}</label>
                                    </div>

                                </Grid>



                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='data_nastere'
                                            type="date"
                                            step='any'
                                            className='add-project-input'
                                            placeholder='Data Nasterii'
                                            margin="normal"
                                            name='data_nastere'
                                            value={this.props.angajat.data_nastere || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='nume_familie'>{this.dictionary.pontaje.dataNastere}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={8} sm={8} md={8} lg={8} xl={8}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='adresa'
                                            type="text"
                                            step='any'
                                            className='add-project-input'
                                            placeholder='Ex: Str. Locuintei nr. 3'
                                            margin="normal"
                                            name='adresa'
                                            value={this.props.angajat.adresa || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='telefon'>{this.dictionary.pontaje.adresaResedinta}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='oras'
                                            type="text"
                                            step='any'
                                            className='add-project-input'
                                            placeholder='Ex: Bucuresti'
                                            margin="normal"
                                            name='oras'
                                            value={this.props.angajat.oras || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='telefon'>{this.dictionary.pontaje.oras}</label>
                                    </div>

                                </Grid>


                                <Grid style={{ textAlign: 'left', marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <Switch
                                        className={!this.state.permis ? '' : "pm-switch"}
                                        checked={this.state.permis}
                                        onChange={(ev) => { this.setState({ permis: ev.target.checked }) }}
                                        value='permis'
                                    />
                                    <span style={{ fontWeight: 500, color: 'black', fontSize: 12 }}> {this.dictionary.pontaje.permis}</span>

                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='permis_conducere'
                                            type="text"
                                            step='any'
                                            className='add-project-input'
                                            margin="normal"
                                            disabled={!this.state.permis}
                                            name='permis_conducere'
                                            value={this.props.angajat.permis_conducere || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='permis_conducere'>{this.dictionary.pontaje.categoriePermis}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{
                                        textAlign: 'left', paddingLefft: 20, marginTop: 10, fontSize: 16,
                                        fontWeight: 500
                                    }} > {this.dictionary.pontaje.dateIdentificare}</h5>
                                </Grid>

                                <Grid style={{ marginBottom: 20, textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='cnp'
                                            type="number"
                                            step='any'
                                            className='add-project-input'
                                            margin="normal"
                                            name='cnp'
                                            value={this.props.angajat.cnp || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={() => { this.validateInput('cnp') }}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='cnp'>{this.dictionary.pontaje.cnp}</label>
                                    </div>

                                    {this.state.vCnp &&
                                        <span style={{
                                            fontSize: 12,
                                            color: 'red',
                                            paddingLeft: 6
                                        }}>{this.state.vCnp}</span>
                                    }

                                </Grid>

                                <Grid style={{ marginBottom: 20, textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='serie_ci'
                                            type="text"
                                            step='any'
                                            className='add-project-input'
                                            margin="normal"
                                            name='serie_ci'
                                            value={this.props.angajat.serie_ci || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={() => { this.validateInput('serie_ci') }}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='serie_ci'>{this.dictionary.pontaje.serieCi}</label>
                                    </div>

                                    {this.state.vSerie &&
                                        <span style={{
                                            fontSize: 12,
                                            color: 'red',
                                            paddingLeft: 6
                                        }}>{this.state.vSerie}</span>
                                    }
                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{
                                        textAlign: 'left', paddingLefft: 20, marginTop: 10, fontSize: 14,
                                        fontWeight: 500
                                    }} > {this.dictionary.pontaje.dateContact}</h5>
                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='telefon'
                                            type="number"
                                            step='any'
                                            className='add-project-input'
                                            placeholder='Selecteaza'
                                            margin="normal"
                                            name='telefon'
                                            value={this.props.angajat.telefon || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='telefon'>{this.dictionary.pontaje.nrTelefon}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='email'
                                            type="text"
                                            step='any'
                                            className='add-project-input'
                                            placeholder='Email'
                                            margin="normal"
                                            name='email'
                                            value={this.props.angajat.email || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='telefon'>{this.dictionary.pontaje.email}</label>
                                    </div>

                                </Grid>







                            </Grid>

                        </Grid>


                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40, overflow: 'scroll', width: '90%', }}>
                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, marginTop: 10, fontSize:16, fontWeight:500 }} > {this.dictionary.pontaje.dateAngajare}
                                        <i style={{ marginLeft: 10, color: 'rgb(24	165	58)', verticalAlign: 'bottom' }} className='material-icons'>verified</i>
                                    </h5>
                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='functie'
                                            type="text"
                                            step='any'
                                            className='add-project-input'
                                            placeholder={'Functie'}
                                            margin="normal"
                                            name='functie'
                                            value={this.props.angajat.functie || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='telefon'>{this.dictionary.pontaje.functie}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <select
                                            id='departament'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='id_departament'
                                            // disabled={this.state.departamentDisabled !== 1 ? true : false}
                                            value={this.props.angajat.id_departament || "-1"}
                                            onChange={this.props.changeAngajatData}
                                            placeholder={this.dictionary.pontaje.departamentCautaLucrator}
                                            onBlur={this.props.updateAngajatData}
                                        >


                                            {this.props.departamente.map((s, idx) => {
                                                return (
                                                    <option key={idx} value={s.id}>{s.nume}</option>
                                                )
                                            })}
                                        </select>
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='tipCost'>{this.dictionary.pontaje.departament}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <select
                                            id='departament'
                                            style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                            className='add-project-input'
                                            type="text"
                                            margin="normal"
                                            name='id_departament'
                                            readOnly
                                            // disabled={this.state.departamentDisabled !== 1 ? true : false}
                                            value={1}
                                            onClick={this.props.openProgramLucru}
                                            // onChange={this.props.changeAngajatData}
                                            placeholder={this.dictionary.pontaje.departamentCautaLucrator}
                                        // onBlur={this.props.updateAngajatData}
                                        >



                                            <option value={1}>{this.dictionary.pontaje.adaugaProgram}</option>

                                        </select>
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='tipCost'>{this.dictionary.pontaje.programLucru}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{
                                        textAlign: 'left', paddingLefft: 20, marginTop: 10, fontSize: 14,
                                        fontWeight: 500
                                    }} > {this.dictionary.pontaje.salarizare}</h5>
                                </Grid>



                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='salariu_brut'
                                            type="number"
                                            step='any'
                                            className='add-project-input'
                                            placeholder={'Ex: 2500 lei'}
                                            margin="normal"
                                            name='salariu_brut'
                                            value={this.props.angajat.salariu_brut || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='telefon'>{this.dictionary.pontaje.salariuBrut}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='salariu'
                                            type="number"
                                            step='any'
                                            className='add-project-input'
                                            placeholder={'Ex: 2223 lei'}
                                            margin="normal"
                                            name='salariu'
                                            value={this.props.angajat.salariu || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label'  htmlFor='telefon'>{this.dictionary.pontaje.salariuLunarNet}</label>
                                    </div>

                                </Grid>

                                <Grid style={{ marginBottom: 20 }} item xs={4} sm={4} md={4} lg={4} xl={4}>
                                    <div style={{ position: 'relative', textAlign: 'left' }}>
                                        <input
                                            style={{ fontSize: 14, fontWeight: 400, width: '90%', }}
                                            id='tichete_masa'
                                            type="number"
                                            step='any'
                                            className='add-project-input'
                                            placeholder={'Ex: 250 lei'}
                                            margin="normal"
                                            name='tichete_masa'
                                            value={this.props.angajat.tichete_masa || ''}
                                            onChange={this.props.changeAngajatData}
                                            onBlur={this.props.updateAngajatData}
                                        />
                                        <label className='inputLabelPM pm-fisa-personala-label' htmlFor='telefon'>{this.dictionary.pontaje.ticheteDeMasa}</label>
                                    </div>

                                </Grid>





                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20, marginTop: 10, fontSize:16, fontWeight:500 }} > {this.dictionary.pontaje.documenteAngajare}
                                    </h5>
                                </Grid>


                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Grid container >

                                        <input type='file' id={`document${this.props.angajat.id}`}
                                            style={{ display: 'none' }}
                                            accept='*'
                                            onChange={() => { this.uploadDocument(`document${this.props.angajat.id}`, this.props.angajat.id) }} />


                                        {this.state.docs.map((d, idx) => {
                                            return (
                                                <Grid key={idx} style={{ padding: 10 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                                    <div
                                                        onClick={d.token ? () => { this.goToDoc(d) } : () => { this.selectFile(`document${this.props.angajat.id}`) }}
                                                    >

                                                        <div style={{
                                                            width: '90%',
                                                            margin: 'auto',
                                                            height: 90,
                                                            marginTop: 20,
                                                            border: '4px dashed rgb(171 171 171 )',
                                                            borderRadius: 10,
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center',
                                                        }}>
                                                            <div>
                                                                <i style={{ color: d.icon_color, fontSize: d.icon_font }} className='material-icons'>{d.icon}</i>
                                                                <span style={{ fontSize: 12, display: 'block', fontWeight: 400, color: 'rgb(121	121	121	)' }}>{d.name}</span>
                                                                <span></span>

                                                            </div>
                                                        </div>

                                                        <span style={{ fontSize: 12, display: 'block', fontWeight: 400, marginTop: 10 }}>{d.name}</span>

                                                    </div>

                                                </Grid>
                                            )
                                        })}


                                    </Grid>

                                </Grid>

                            </Grid>

                        </Grid>






                    </Grid>


                </Grid>
            </Grid >
        );
    }
}